/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Empty } from '../models/empty';
import { putReleaseDelayedOrder } from '../fn/delayed-order/put-release-delayed-order';
import { PutReleaseDelayedOrder$Params } from '../fn/delayed-order/put-release-delayed-order';

@Injectable({ providedIn: 'root' })
export class DelayedOrderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `putReleaseDelayedOrder()` */
  static readonly PutReleaseDelayedOrderPath = '/aggregators/{aggregatorId}/orders/{orderId}/release';

  /**
   * Release a delayed order.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putReleaseDelayedOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  putReleaseDelayedOrder$Response(params: PutReleaseDelayedOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: Empty;
}>> {
    return putReleaseDelayedOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * Release a delayed order.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putReleaseDelayedOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  putReleaseDelayedOrder(params: PutReleaseDelayedOrder$Params, context?: HttpContext): Observable<{
'_links'?: Empty;
}> {
    return this.putReleaseDelayedOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: Empty;
}>): {
'_links'?: Empty;
} => r.body)
    );
  }

}
